import { render } from "./AddSubsidiary.vue?vue&type=template&id=e1182346&scoped=true&ts=true"
import script from "./AddSubsidiary.vue?vue&type=script&lang=ts"
export * from "./AddSubsidiary.vue?vue&type=script&lang=ts"

import "./AddSubsidiary.vue?vue&type=style&index=0&id=e1182346&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1182346"]])

export default __exports__